export default {
  title: 'History',
} as const;
